// Tab mapping for URL parameters - maps tab index to tab value
const TAB_INDEX_MAP = [
  'Requests', // 0
  'PropertyHistory', // 1
  'Equipment', // 2
  'Services', // 3
  'Notes', // 4
  'NewProposal', // 5
  'CustomerProposal', // 6
  'Invoice', // 7
  'InvoiceNew', // 8
  'PaymentLink', // 9
  'InvoicePayment', // 10
  'Spiffs', // 11
  'PieceWorkOptions', // 12
];

// Reverse mapping for generating URLs
export const TAB_VALUE_TO_INDEX_MAP: Record<string, number> = TAB_INDEX_MAP.reduce(
  (acc, tabValue, index) => {
    acc[tabValue] = index;
    return acc;
  },
  {} as Record<string, number>,
);

// Function to get tab value from index
export const getTabValueFromIndex = (index: number): string => {
  if (index >= 0 && index < TAB_INDEX_MAP.length) {
    return TAB_INDEX_MAP[index];
  }
  return 'Requests'; // Default fallback
};

/** Maps legacy /jobs?defaultTab= index to Job Details (`/job-details`) tab `value`. */
const LEGACY_TAB_INDEX_TO_JOB_DETAILS_TAB: string[] = [
  'overview', // 0 Requests
  'property', // 1 PropertyHistory
  'systems', // 2 Equipment
  'services-rendered', // 3 Services
  'overview', // 4 Notes
  'proposal', // 5 NewProposal
  'proposal', // 6 CustomerProposal
  'invoice', // 7 Invoice
  'invoice', // 8 InvoiceNew
  'invoice', // 9 PaymentLink
  'invoice', // 10 InvoicePayment
  'overview', // 11 Spiffs
  'overview', // 12 PieceWorkOptions
];

export function legacyJobTabIndexToJobDetailsTab(index: number): string {
  if (index >= 0 && index < LEGACY_TAB_INDEX_TO_JOB_DETAILS_TAB.length) {
    return LEGACY_TAB_INDEX_TO_JOB_DETAILS_TAB[index] ?? 'overview';
  }
  return 'overview';
}
